import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function getDailyHighlightsTweets() {
  const url = `${backendUrl}/api/forecasters/tweets/daily-highlights/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении ежедневных выжимок');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterDailyHighlights error:', error);
    throw error;
  }
}

export async function getDailyHighlightsTelegram() {
  const url = `${backendUrl}/api/forecasters/telegram/daily-highlights/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении ежедневных выжимок');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterDailyHighlights error:', error);
    throw error;
  }
}